import styles from './index.module.scss';
import {Card} from "antd";
import {useTranslation} from "react-i18next";

export const InvestmentDetails = ({ data, loading }: any) => {
	const { t } = useTranslation();
	return (
		<Card bordered={false} loading={loading} className={styles.card}>
			<div className={styles.heading}>
				{t('Investment details')}
			</div>
			<div className={styles.root}>
				<div>
					<span>{t('investedAmountText')}</span>
					<span>€{data?.investment?.investedAmount}</span>
				</div>
				<div>
					<span>{t('interestRateText')}</span>
					<span>{data?.investment?.interestRate}%</span>
				</div>
				<div>
					<span>{t('dateOfInvestmentText')}</span>
					<span>{data?.investment?.dateOfInvestment}</span>
				</div>
				<div>
					<span>{t('Received principal')}</span>
					<span>€{data?.investment?.receivedPrincipal}</span>
				</div>
				<div>
					<span>{t('Received interests')}</span>
					<span>€{data?.investment?.receivedInterest}</span>
				</div>
			</div>
		</Card>
	)
}

export default InvestmentDetails;
